import { render, staticRenderFns } from "./wasteInformation.vue?vue&type=template&id=44753a02&scoped=true"
import script from "./wasteInformation.vue?vue&type=script&lang=js"
export * from "./wasteInformation.vue?vue&type=script&lang=js"
import style0 from "./wasteInformation.vue?vue&type=style&index=0&id=44753a02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44753a02",
  null
  
)

export default component.exports